import { Temporal } from "temporal-polyfill";
import type { RouterOutputs } from "@/trpc";

/** DatePicker requires a local Date; credential dates themselves are calendar dates. */
function pickerDate(value: string | null | undefined): Date | null {
  if (!value) {
    return null;
  }
  const date = Temporal.PlainDate.from(value);
  return new Date(date.year, date.month - 1, date.day);
}

export function onboardingLicenseValues(
  saved: RouterOutputs["providerOnboarding"]["getSavedDetails"]["licenses"],
) {
  return {
    stateLicenses: saved.stateLicenses.map((license) => ({
      credentialId: license.credentialId,
      legacyStateCode: license.legacyStateCode,
      state: license.stateCode,
      license_number: license.number ?? "",
      expiration_date: pickerDate(license.expiresAt),
    })),
    hasImlc: saved.hasImlc,
  };
}
